import React, { memo } from "react";
import PropTypes from "prop-types";
import { parseCssStringToObject } from "../../../../helper";
import { useApp } from "../../../../context/AppState";

/** Minimum editor hit area (DraggableWrapper box); line thickness stays in customCSS.height */
export const DIVIDER_EDITOR_MIN_HEIGHT = 32;

const DividerBlock = ({ section, fullWidth = false }) => {
  const { isMobile } = useApp();
  const viewport = isMobile ? "mobile" : "desktop";

  const customCSS = section?.setting?.customCSS?.[viewport] || {};
  const overrideCss = parseCssStringToObject(
    section?.setting?.overrideCss?.[viewport]
  );

  const widthUnit = customCSS.widthUnit ?? "px";
  const heightUnit = customCSS.heightUnit ?? "px";
  const lineHeightRaw = Number(customCSS.height) || 2;
  const lineHeight = `${lineHeightRaw}${heightUnit}`;
  const lineColor =
    customCSS.backgroundColor ||
    customCSS.color ||
    overrideCss.backgroundColor ||
    "#D4D4D4";

  const lineWidth =
    fullWidth || widthUnit === "%"
      ? "100%"
      : `${customCSS.width ?? 200}${widthUnit}`;

  const lineStyle = {
    width: lineWidth,
    maxWidth: "100%",
    height: lineHeight,
    minHeight: lineHeight,
    backgroundColor: lineColor,
    border: "none",
    borderRadius: customCSS.borderRadius ?? overrideCss.borderRadius ?? 0,
    display: "block",
    flexShrink: 0,
    boxSizing: "border-box",
  };

  if (fullWidth) {
    return (
      <div
        className="weupsell-cart-drawer-divider-line"
        role="separator"
        aria-hidden
        style={lineStyle}
      />
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: DIVIDER_EDITOR_MIN_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        pointerEvents: "auto",
        cursor: "move",
      }}
    >
      <div role="separator" aria-hidden style={lineStyle} />
    </div>
  );
};

DividerBlock.propTypes = {
  section: PropTypes.object,
  fullWidth: PropTypes.bool,
};

export default memo(DividerBlock);
